var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 571 571",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 498 373 C 498 400 477 423 452 423 L 67 423 C 42 423 21 400 21 373 L 21 197 C 21 170 42 148 67 148 L 452 148 C 477 148 498 170 498 197 L 498 199 550 199 550 371 498 371 498 373 Z M 99 302 C 98 307 101 312 105 312 L 264 323 C 267 323 270 321 272 318 273 317 273 317 273 317 275 314 275 310 274 307 L 270 294 419 279 C 422 279 424 276 426 272 427 271 427 269 428 268 429 263 426 259 422 258 L 251 244 C 248 244 245 245 243 249 242 249 242 249 242 250 240 253 240 256 241 259 L 246 278 108 292 C 105 293 103 295 101 298 100 299 100 301 99 302 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.c706db1f2054f72aca0fefb5909e7eb7.svg";
export { ForwardRef as ReactComponent };